import { render, staticRenderFns } from "./GlobalCountsPieChart.vue?vue&type=template&id=a3748506&"
import script from "./GlobalCountsPieChart.vue?vue&type=script&lang=js&"
export * from "./GlobalCountsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports